import { render } from "./CategoryEleven.vue?vue&type=template&id=550d2154"
import script from "./CategoryEleven.vue?vue&type=script&lang=ts"
export * from "./CategoryEleven.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
